import React from "react";
import { Link as ReactRouterLink } from "react-router-dom";
import {
    Box,
    Flex,
    HStack,
    IconButton,
    Button,
    useDisclosure,
    Drawer,
    DrawerBody,
    DrawerHeader,
    DrawerContent,
    VStack,
    Link,
} from "@chakra-ui/react";
import { HamburgerIcon, CloseIcon } from "@chakra-ui/icons";
import logoWhite from "../assets/logo-white.svg";

const Navbar = () => {
    const { isOpen, onOpen, onClose } = useDisclosure();

    const navItems = [
        { label: "How it works", path: "/how-it-works" },
        { label: "HRBP", path: "/hrbp" },
        { label: "Talent acquisition", path: "/recruiters" },
        { label: "Occupational psychologists", path: "/professionals" },
        { label: "Security & data", path: "/security-and-data" },
        { label: "About", path: "/about" },
        { label: "Talk to us", path: "/contact" },
    ];

    return (
        <Box bg="navy.500" px={4}>
            <Flex h={20} alignItems="center" justifyContent="space-between">
                <Link as={ReactRouterLink} to="/">
                    <img src={logoWhite} alt="BetaPersona Logo" />
                </Link>

                <HStack
                    display={{ base: "none", lg: "flex" }}
                    spacing={2}
                    alignItems="center"
                    direction="row"
                >
                    <HStack
                        as="nav"
                        spacing={1}
                        display={{ base: "none", lg: "flex" }}
                    >
                        {navItems.map((item) => (
                            <Link
                                key={item.path}
                                as={ReactRouterLink}
                                to={item.path}
                                _hover={{ textDecoration: "none" }}
                            >
                                <Button
                                    variant="link"
                                    fontSize={{ lg: "14px", xl: "16px" }}
                                    color="white"
                                    px={3}
                                    m={0}
                                    _hover={{ opacity: 0.8 }}
                                >
                                    {item.label}
                                </Button>
                            </Link>
                        ))}
                    </HStack>
                    <Button
                        onClick={() =>
                            window.open(
                                "https://reportengine.pages.dev/",
                                "_blank"
                            )
                        }
                        bg="rgba(244, 244, 244, 0.12)"
                        _hover={{ bg: "rgba(244, 244, 244, 0.30)" }}
                        color="white"
                        m={0}
                    >
                        Log in
                    </Button>
                </HStack>

                <IconButton
                    size="md"
                    icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
                    aria-label="Open Menu"
                    display={{ lg: "none" }}
                    onClick={onOpen}
                />

                <Drawer placement="right" isOpen={isOpen} onClose={onClose}>
                    <DrawerContent>
                        <DrawerHeader
                            display="flex"
                            justifyContent="space-between"
                        >
                            <Button
                                onClick={() =>
                                    window.open(
                                        "https://reportengine.pages.dev/",
                                        "_blank"
                                    )
                                }
                                bg="navy.500"
                                color="white"
                                fontWeight="bold"
                                m={0}
                            >
                                Log in
                            </Button>
                            <Button onClick={onClose}>×</Button>
                        </DrawerHeader>
                        <DrawerBody
                            pb="6em"
                            display="flex"
                            flexDir="column"
                            justifyContent="start"
                        >
                            <VStack spacing={4} align="stretch">
                                {navItems.map((item) => (
                                    <Link
                                        key={item.path}
                                        as={ReactRouterLink}
                                        to={item.path}
                                        onClick={onClose}
                                        _hover={{ textDecoration: "none" }}
                                    >
                                        <Button
                                            variant="link"
                                            fontSize={{ base: "18px", md: "20px" }}
                                            color="ink.500"
                                            textAlign="left"
                                            w="full"
                                            justifyContent="flex-start"
                                        >
                                            {item.label}
                                        </Button>
                                    </Link>
                                ))}
                            </VStack>
                        </DrawerBody>
                    </DrawerContent>
                </Drawer>
            </Flex>
        </Box>
    );
};

export default Navbar;
